module.exports = __webpack_public_path__ + "6a304903af32117139ac36af228468a6.svg";